import React, { useState } from "react";
import { FiPlay, FiHelpCircle, FiInfo, FiClock, FiAward } from "react-icons/fi";
import QuizSession from "./QuizSession";
import styles from "../styles/home.module.css";

const QuizMessage = ({ quiz, onComplete }) => {
  const [isStarted, setIsStarted] = useState(false);

  const handleStartQuiz = () => {
    setIsStarted(true);
  };

  const handleQuizComplete = (results) => {
    setIsStarted(false);
    if (onComplete) {
      onComplete(results);
    }
  };

  const handleQuizExit = () => {
    setIsStarted(false);
  };

  return (
    <div className={styles.inlineLearningContainer}>
      <div className={styles.inlineLearningHeader}>
        <div className={styles.inlineHeaderLeft}>
          <FiHelpCircle className={styles.quizIcon} />
          <div>
            <h3 className={styles.inlineTitle}>{quiz.title}</h3>
            {quiz.description && <p className={styles.inlineSubtitle}>{quiz.description}</p>}
          </div>
        </div>
        {!isStarted && (
          <button onClick={handleStartQuiz} className={styles.primaryButton}>
            <FiPlay /> Start Quiz
          </button>
        )}
      </div>

      {!isStarted && (
        <div className={styles.inlineMetaRow}>
          <span className={styles.metaPill}><FiInfo /> {quiz.cards.length} questions</span>
          <span className={styles.metaPill}><FiClock /> ~{Math.ceil(quiz.cards.length * 0.75)} min</span>
          <span className={styles.metaPill}><FiAward /> Knowledge check</span>
        </div>
      )}

      {!isStarted && quiz.cards?.length > 0 && (
        <div className={styles.previewChips}>
          {quiz.cards.slice(0, 3).map((card, i) => (
            <div key={i} className={styles.previewChip}>
              {card.question.length > 40 ? card.question.substring(0, 40) + "..." : card.question}
            </div>
          ))}
          {quiz.cards.length > 3 && (
            <div className={styles.previewMore}>+{quiz.cards.length - 3} more</div>
          )}
        </div>
      )}

      {isStarted && (
        <div className={styles.inlineLearningBody}>
          <QuizSession quizData={quiz} onComplete={handleQuizComplete} onExit={handleQuizExit} />
        </div>
      )}
    </div>
  );
};

export default QuizMessage;
